import ConsultarAditivosContrato from "@/views/licitacoes/aditivos-contrato/ConsultarAditivosContrato.vue";
import DetalhesAditivoContrato from "@/views/licitacoes/aditivos-contrato/DetalhesAditivoContrato.vue";
import EditarAditivoContrato from "@/views/licitacoes/aditivos-contrato/EditarAditivoContrato.vue";
import ImportarXmlAditivoContrato from "@/views/licitacoes/aditivos-contrato/ImportarXmlAditivoContrato.vue";

import ConsultarAditivosConvenio from "@/views/licitacoes/aditivos-convenio/ConsultarAditivosConvenio.vue";
import DetalhesAditivoConvenio from "@/views/licitacoes/aditivos-convenio/DetalhesAditivoConvenio.vue";
import EditarAditivoConvenio from "@/views/licitacoes/aditivos-convenio/EditarAditivoConvenio.vue";
import ImportarXmlAditivoConvenio from "@/views/licitacoes/aditivos-convenio/ImportarXmlAditivoConvenio.vue";

import ConsultarConvenios from "@/views/licitacoes/convenios/ConsultarConvenios.vue";
import DetalhesConvenio from "@/views/licitacoes/convenios/DetalhesConvenio.vue";
import EditarConvenio from "@/views/licitacoes/convenios/EditarConvenio.vue";
import ImportarXmlConvenio from "@/views/licitacoes/convenios/ImportarXmlConvenio.vue";

import ConsultarLDI from "@/views/licitacoes/ldi/ConsultarLDI.vue";
import DetalhesLDI from "@/views/licitacoes/ldi/DetalhesLDI.vue";
import EditarLicitacao from "@/views/licitacoes/ldi/EditarLicitacao.vue";
import EditarDispensaInex from "@/views/licitacoes/ldi/EditarDispensaInex.vue";
import EditarDispensaEletronica from "@/views/licitacoes/ldi/EditarDispensaEletronica.vue";

import ConsultarContratosOF from "@/views/licitacoes/contratos/ConsultarContratosOF.vue";
import DetalhesContratosOF from "@/views/licitacoes/contratos/DetalhesContratosOF.vue";
import EditarContrato from "@/views/licitacoes/contratos/EditarContrato.vue";

const licitacoesRotas = [
  {
    path: "/modulo-licitacoes/aditivos-contratos",
    name: "licitacoes--aditivos-contrato",
    component: ConsultarAditivosContrato,
  },
  {
    path: "/modulo-licitacoes/aditivos-contratos/novo",
    name: "licitacoes--aditivos-contratos--novo",
    component: EditarAditivoContrato,
  },
  {
    path: "/modulo-licitacoes/aditivos-contratos/importar-xml",
    name: "ImportarXmlAditivoContrato",
    component: ImportarXmlAditivoContrato,
  },
  {
    path: "/modulo-licitacoes/aditivos-contratos/editar/:idAditivo?",
    name: "licitacoes--aditivos-contrato--editar",
    component: EditarAditivoContrato,
    props: true,
  },
  {
    path: "/modulo-licitacoes/aditivos-contratos/:idAditivo",
    name: "licitacoes--aditivos-contratos--detalhes",
    component: DetalhesAditivoContrato,
    props: true,
  },

  {
    //ROTAS DE ADITIVOS DE CONVÊNIOS
    path: "/modulo-licitacoes/aditivos-convenios-outros-instrumentos-congeneres",
    name: "licitacoes--aditivos-convenio",
    component: ConsultarAditivosConvenio,
  },
  {
    path: "/modulo-licitacoes/aditivos-convenios/novo",
    name: "licitacoes--aditivos-convenios--novo",
    component: EditarAditivoConvenio,
  },
  {
    path: "/modulo-licitacoes/aditivos-convenios/importar-xml",
    name: "ImportarXmlAditivoConvenio",
    component: ImportarXmlAditivoConvenio,
  },
  {
    path: "/modulo-licitacoes/aditivos-convenios/editar/:idAditivo?",
    name: "licitacoes--aditivos-convenios--editar",
    component: EditarAditivoConvenio,
    props: true,
  },
  {
    path: "/modulo-licitacoes/aditivos-convenios/:idAditivo",
    name: "licitacoes--aditivos-convenios--detalhes",
    component: DetalhesAditivoConvenio,
    props: true,
  },

  {
    //ROTAS DE CONVÊNIOS
    path: "/modulo-licitacoes/convenios-outros-instrumentos-congeneres",
    name: "licitacoes--convenio",
    component: ConsultarConvenios,
  },
  {
    path: "/modulo-licitacoes/convenios/novo",
    name: "licitacoes--convenios--novo",
    component: EditarConvenio,
  },
  {
    path: "/modulo-licitacoes/convenios/importar-xml",
    name: "ImportarXmlConvenio",
    component: ImportarXmlConvenio,
  },
  {
    path: "/modulo-licitacoes/convenios/editar/:idConvenio?",
    name: "licitacoes--convenios--editar",
    component: EditarConvenio,
    props: true,
  },
  {
    path: "/modulo-licitacoes/convenios/:idConvenio",
    name: "licitacoes--convenios--detalhes",
    component: DetalhesConvenio,
    props: true,
  },

  {
    //ROTAS DE LICITAÇÕES
    path: "/modulo-licitacoes/licitacoes-dispensas-inexigibilidades",
    name: "licitacoes--ldi",
    component: ConsultarLDI,
  },
  {
    path: "/modulo-licitacoes/ldi/detalhes/:idLicitacao",
    name: "licitacoes--ldi--detalhes",
    component: DetalhesLDI,
    props: true,
  },
  {
    path: "/modulo-licitacoes/ldi/editarLicitacao/:idLicitacao?",
    name: "licitacoes--ldi--editar-licitacao",
    component: EditarLicitacao,
    props: true,
  },
  {
    path: "/modulo-licitacoes/ldi/editarDispensaEletronica/:idLicitacao?",
    name: "licitacoes--ldi--editar-dispensa-eletronica",
    component: EditarDispensaEletronica,
    props: true,
  },
  {
    path: "/modulo-licitacoes/ldi/editarDispensaInex/:idLicitacao?",
    name: "licitacoes--ldi--editar-dispensa-inex",
    component: EditarDispensaInex,
    props: true,
  },
  //ROTAS DE CONTRATOS
  {
    path: "/modulo-licitacoes/contratos/contratos-ordens-fornecimento",
    name: "licitacoes--contratos--contratos-ordens-fornecimento",
    component: ConsultarContratosOF,
    props: true,
  },
  {
    path: "/modulo-licitacoes/contratos/detalhes/:idContrato",
    name: "licitacoes--contratos--detalhes",
    component: DetalhesContratosOF,
    props: true,
  },
  {
    path: "/modulo-licitacoes/contratos/editar/:idContrato?",
    name: "licitacoes--contratos--editar-contrato",
    component: EditarContrato,
    props: true,
  },
];

export { licitacoesRotas };
